// extracted by mini-css-extract-plugin
export var addButton = "_o8-0";
export var border = "_o8-8";
export var check = "_o8-h";
export var danger = "_o8-6";
export var dropdownContainer = "_o8-1";
export var editModalBody = "_o8-j";
export var footerContainer = "_o8-i";
export var fullWidth = "_o8-a";
export var hide = "_o8-9";
export var icon = "_o8-3";
export var input = "_o8-7";
export var inputFlex = "_o8-b";
export var inputWrapper = "_o8-c";
export var manualFocus = "_o8-5";
export var optionButton = "_o8-4";
export var pillWrapper = "_o8-e";
export var pointer = "_o8-2";
export var showOverflow = "_o8-f";
export var tagsFlex = "_o8-d";
export var xButton = "_o8-g";